import React from 'react'
import Button from '/react4xp/components/Button'

interface Props {
   tag?: string,
   title: string,
   img?: {
      src: string,
      srcMobile: string,
      alt: string,
   },
   cards?: {
      startDate: {
         day: string,
         month: string,
         year: string,
      },
      endDate?: {
         day: string,
         month: string,
         year: string,
      },
      title: string,
      address: string,
      stand: string,
   }[],
   cta?: {
      label: string,
      url: string,
      isExternal?: boolean,
   },
   color?: string,
}

export default function EventList(props: Props) {
   const { tag, title, img, cards, cta, color } = props

   return (
      <div className={`event-list ${color === 'secondary' ? 'event-list--secondary' : ''}`}>
         <div className="grid-container">
            <div className="grid-row">
               <div className="c-12 event-list__wrapper">
                  <div className="event-list__main">
                     <div className="header">
                        {tag && <div className="tag">{tag}</div>}
                        {title && <div className="title font-title">{title}</div>}
                     </div>
                     {
                        img.src &&
                        <figure>
                           <picture>
                              <source
                                 media="(min-width: 768px)"
                                 srcSet={img.src}
                              />
                              <source
                                 media="(max-width: 767px)"
                                 srcSet={img.srcMobile}
                              />
                              <img src={img.src} alt={img.alt ? img.alt : 'Image'} />
                           </picture>
                        </figure>
                     }
                  </div>
                  {cards.length !== 0 && <div className="event-list__cards">
                     {cards.map((card, index) => (
                        <div className="card" key={index}>
                           <div className="card-wrapper">

                              <div className="card-wrapper__inner">

                                 <div className="date date--start">
                                    <p>{card.startDate.month} {card.startDate.day}</p>
                                    <div className="year">{card.startDate.year}</div>
                                 </div>

                                 {/* card.endDate && (
                                    <>

                                       <p className='card-wrapper__separator'>
                                          -
                                       </p>

                                       <div className="date date--end">
                                          <p>{card.endDate.month} {card.endDate.day}</p>
                                          <div className="year">{card.endDate.year}</div>
                                       </div>

                                    </>
                                 ) */}

                              </div>

                              <div className="content">
                                 <div className="title">{card.title}</div>
                                 <div className="address">{card.address}</div>
                                 <div className="stand">Stand: {card.stand}</div>
                              </div>
                           </div>
                        </div>
                     ))}
                  </div>}
               </div>
            </div>
            {cta && (
               <div className="event-list__cta">
                  {cta.url && <Button className={`btn btn--icon btn--${color}`} href={cta.url} target={cta.isExternal} size='xs' rightIcon='ArrowRight'>
                     {cta.label}
                  </Button>}
               </div>
            )}
         </div>
      </div>
   )
}